import { render, staticRenderFns } from "./TotalAbsencePerDayReport.vue?vue&type=template&id=540a2def"
import script from "./TotalAbsencePerDayReport.vue?vue&type=script&lang=js"
export * from "./TotalAbsencePerDayReport.vue?vue&type=script&lang=js"
import style0 from "./TotalAbsencePerDayReport.vue?vue&type=style&index=0&id=540a2def&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports